<div class="row">
  <div class="col-12 {{ lang === 'en' ? 'text-left' : '' }}">
    <button class="btn chng-lang" (click)="changeLang()">
      {{ lang === "en" ? "العربية" : "English" }}
    </button>
  </div>
</div>
